import { render, staticRenderFns } from "./attributes.column.vue?vue&type=template&id=2f30252a&"
import script from "./attributes.column.vue?vue&type=script&lang=ts&"
export * from "./attributes.column.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../../../tmp/ffsecurity-ui/node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports